import React from 'react';
import PropTypes from 'prop-types';
import ForgeStack from '../ForgeStack/ForgeStack.js';
import {
  ForgeButton,
  ForgeToolbar,
  ForgeTooltip,
} from '@tylertech/forge-react';
import { CANCEL } from '../../../static/keyWords.js';
import SplitButton from '../SplitButton.js';

const PRIMARY_BUTTON_ID = 'COMMITED_CHANGE_BUTTONS_PRIMARY_BUTTON_ID';

const CommittedChangeButtons = ({
  showCommittedChangeSecondaryButton,
  disableCommittedChangeCancelButton = true,
  disableCommittedChangePrimaryButton,
  disableCommittedChangeSecondaryButton,
  primaryButtonText,
  secondaryButtonText,
  handleClickPrimaryButton,
  handleClickSecondaryButton,
  handleClickCancelButton,
  primaryButtonTooltip,
  primaryAsSplitButton,
  splitButtonOptions,
}) => {
  return (
    <ForgeToolbar inverted slot="footer" className={'fixed-footer'}>
      <div slot="start">
        <ForgeButton
          onClick={handleClickCancelButton}
          disabled={disableCommittedChangeCancelButton}
          variant={'outlined'}
        >
          {CANCEL}
        </ForgeButton>
      </div>
      <div slot="end">
        <ForgeStack inline>
          {showCommittedChangeSecondaryButton && (
            <ForgeButton
              variant="outlined"
              disabled={disableCommittedChangeSecondaryButton}
              onClick={handleClickSecondaryButton}
            >
              {secondaryButtonText}
            </ForgeButton>
          )}
          {primaryAsSplitButton ?
            <SplitButton
              title={primaryButtonText}
              splitButtonOptions={splitButtonOptions}
            />
            : <ForgeButton
              id={PRIMARY_BUTTON_ID}
              onClick={handleClickPrimaryButton}
              disabled={disableCommittedChangePrimaryButton}
              variant={'raised'}
            >
              {primaryButtonText}
              {primaryButtonTooltip && (
                <ForgeTooltip anchor={PRIMARY_BUTTON_ID} placement="top">
                  {primaryButtonTooltip}
                </ForgeTooltip>
              )}
            </ForgeButton>
          }
        </ForgeStack>
      </div>
    </ForgeToolbar>
  );
};

CommittedChangeButtons.propTypes = {
  showCommittedChangeSecondaryButton: PropTypes.bool,
  disableCommittedChangeCancelButton: PropTypes.bool,
  disableCommittedChangePrimaryButton: PropTypes.bool,
  disableCommittedChangeSecondaryButton: PropTypes.bool,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  handleClickPrimaryButton: PropTypes.func,
  handleClickSecondaryButton: PropTypes.func,
  handleClickCancelButton: PropTypes.func,
  disablePrimaryButton: PropTypes.bool,
  primaryButtonTooltip: PropTypes.string,
  primaryAsSplitButton: PropTypes.bool,
  splitButtonOptions: PropTypes.array,
};

export default CommittedChangeButtons;
